var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFacc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 653.96 372.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#83d3f7;}.cls-2{fill:#ecee58;}.cls-3{fill:#dd0423;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1 111.13 1 30.25 96.48 199.75 66.98 208.75 1 111.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "395.48 312.75 653.96 239.25 653.96 145.75 350.98 282.25 395.48 312.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "653.96 62.75 653.96 0 592.48 0 300.48 255.25 366.48 248.75 653.96 62.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "507.48 0 431.48 0 263.98 239.75 303.48 226.25 507.48 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "324.98 0 377.48 0 244.48 229.25 238.48 198.75 324.98 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "290.98 0 222.98 222.25 217.98 204.25 211.48 187.92 248.98 0 290.98 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "177.48 0 219.48 0 192.98 229.25 177.48 185.88 177.48 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "145.48 0 107.98 0 149.48 206.25 167.98 212.75 145.48 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.98 0 28.48 0 125.98 222.25 133.48 202.75 133.48 196.25 73.98 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1 170.75 1 228.75 51.98 217.75 1 170.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "413.48 372.75 653.96 372.75 653.96 318.75 327.48 345.75 413.48 372.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1 228.75 24.48 223.25 1 194.75 35.98 208.25 0 141.75 56.98 197.25 1 81.75 85.98 192.25 19.98 38.25 106.98 182.75 62.48 41.09 126.48 177.75 104.15 62.09 139.15 175.75 124.81 6.09 160.48 172.42 160.48 42.09 174.48 171.42 190.15 4.09 195.48 173.42 228.48 4.09 214.15 176.42 260.15 12.75 233.48 176.09 292.81 22.09 250.15 180.75 325.48 33.42 269.48 188.09 366.15 53.09 294.81 196.75 387.48 87.42 315.81 210.09 422.48 117.75 340.15 225.09 450.48 157.42 364.81 246.42 470.15 204.75 384.15 270.09 478.81 254.09 398.15 305.75 483.15 305.75 414.81 337.75 478.15 355.75 442.15 371.75 1 371.75 1 228.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.66,241.37H88.11v21.82H39.7v27.26h42v20.16h-42v48.75h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.53,241.37h22.59l37.47,118H157.72l-7.58-26.27H112.67l-7.86,26.27H82.5Zm-2.11,72.38h26l-12.63-43.29h-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256.09,281c-1.4-11.73-10.94-20.65-21.89-20.65-19.79,0-27.23,19.83-27.23,40.48,0,19.67,7.44,39.5,27.23,39.5,13.47,0,21.05-10.91,22.73-26.44h21.33c-2.24,29.41-19.5,48.25-44.06,48.25-31,0-49.26-27.26-49.26-61.31,0-35,18.24-62.3,49.26-62.3,22,0,40.56,15.21,43.22,42.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M360.08,281c-1.4-11.73-10.95-20.65-21.89-20.65-19.79,0-27.23,19.83-27.23,40.48,0,19.67,7.44,39.5,27.23,39.5,13.47,0,21.05-10.91,22.73-26.44h21.33c-2.24,29.41-19.5,48.25-44.06,48.25-31,0-49.26-27.26-49.26-61.31,0-35,18.24-62.3,49.26-62.3,22,0,40.55,15.21,43.22,42.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 72.81,
    cy: 352.25,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 192.15,
    cy: 352.25,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 282.93,
    cy: 352.25,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 382.25,
    cy: 352.25,
    r: 6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacc);
export default __webpack_public_path__ + "static/media/logo_facc.c640395756729da9573f1108a7732d4e.svg";
export { ForwardRef as ReactComponent };